import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	pasteErrorTitle: {
		id: 'business-list.controllers.clipboard.paste-error-title',
		defaultMessage: 'Unable to paste',
		description: 'Heading of the error when pasting',
	},
	cutErrorTitle: {
		id: 'business-list.controllers.clipboard.cut-error-title',
		defaultMessage: "We couldn't cut this field",
		description: 'Heading of the error when cutting',
	},
	copyErrorTitle: {
		id: 'business-list.controllers.clipboard.copy-error-title',
		defaultMessage: 'Unable to copy',
		description: 'Heading of the error when copying',
	},
	emptyClipboardTitle: {
		id: 'business-list.controllers.clipboard.empty-clipboard-title',
		defaultMessage: 'Your clipboard is empty',
		description: 'Heading of the validation error when the clipboard is empty.',
	},
	genericServerError: {
		id: 'business-list.controllers.clipboard.generic-server-error',
		defaultMessage: "Your changes couldn't be saved.",
		description: 'Generic text used to represent a server error when saving an issue.',
	},
	pasteUnsupportedError: {
		id: 'business-list.controllers.clipboard.paste-unsupported-error',
		defaultMessage: "This can't be pasted on {name}.",
		description:
			'Validation error when pasting is not supported for the current field. {name} is the field name',
	},
	missingFieldAssociationError: {
		id: 'business-list.controllers.clipboard.missing-field-association-error',
		defaultMessage:
			"Can't paste on {name}, looks like the field is not associated to this issue type.",
		description:
			'Validation error when the field is not associated to the current issue type. {name} is the field name',
	},
	cutNonEditableError: {
		id: 'business-list.controllers.clipboard.cut-non-editable-error',
		defaultMessage: '{name} is copied to your clipboard instead.',
		description:
			'Validation error when cutting is not supported for the current field. {name} is the field name',
	},
	copyValidationError: {
		id: 'business-list.controllers.clipboard.copy-validation-error',
		defaultMessage: "{name} can't be copied.",
		description:
			'Validation error when copying is not supported for the current field. {name} is the field name',
	},
	pasteEmptyClipboardError: {
		id: 'business-list.controllers.clipboard.paste-empty-clipboard-error',
		defaultMessage: 'Cut or copy your data, then try again.',
		description: 'Validation error when the clipboard is empty.',
	},
	missingFieldAssociationErrorIssueTermRefresh: {
		id: 'business-list.controllers.clipboard.missing-field-association-error-issue-term-refresh',
		defaultMessage:
			"Can't paste on {name}, looks like the field is not associated to this work type.",
		description:
			'Validation error when the field is not associated to the current issue type. {name} is the field name',
	},
});
